import { getContext } from '@fiverr-private/fiverr_context';

const LISTINGS_IMPRESSIONS_TYPE = 'CMS_listings_impression';

export const enrichContext = ({ carousel_name, currencyObject }) => {
    const context = getContext();

    return {
        ...context,
        viewportType: LISTINGS_IMPRESSIONS_TYPE,
        pageElementName: carousel_name,
        currency: currencyObject,
    };
};
